module.exports = __webpack_public_path__ + "img/bg_resize_fg_grass_3_der.fd039e2f.png";